import { PartnerInfoListInterface } from "../interface/partner.interface";

export const PARTNER_INFO: PartnerInfoListInterface = {
	carsome: {
		isDisplay: true,
		partner: "carsome",
		company: "Carsome",
		email: { value: "capital.insurance@carsome.my", isDisplay: true },
		mobile: { value: "", isDisplay: false },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false,
		},
		copyright: { value: "Carsome Sdn Bhd (201401025864)", isDisplay: false },
	},
	carsomereferral: {
		isDisplay: true,
		partner: "carsomereferral",
		company: "Carsome Referral",
		email: { value: "capital.insurance@carsome.my", isDisplay: true },
		mobile: { value: "", isDisplay: false },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false,
		},
		copyright: { value: "Carsome Sdn Bhd (201401025864)", isDisplay: false },
	},
	wapcar: {
		isDisplay: true,
		partner: "carsome",
		company: "Carsome",
		email: { value: "capital.insurance@carsome.my", isDisplay: true },
		mobile: { value: "", isDisplay: false },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false,
		},
		copyright: { value: "Carsome Sdn Bhd (201401025864)", isDisplay: false },
	},
	carlist: {
		isDisplay: true,
		partner: "carsome",
		company: "Carsome",
		email: { value: "capital.insurance@carsome.my", isDisplay: true },
		mobile: { value: "", isDisplay: false },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false,
		},
		copyright: { value: "Carsome Sdn Bhd (201401025864)", isDisplay: false },
	},
  ktmb: {
    isDisplay: true,
    partner: "ktmb",
    company: "KTMB",
    email: { value: "customerservice@policystreet.com", isDisplay: true },
    mobile: { value: "+6018-2822320", isDisplay: true },
    address: {
      value:
        "Block D, Platinum Sentral, Jalan Stesen Sentral 2, Level 3-5, Kuala Lumpur, 50470, Malaysia",
      isDisplay: true
    },
    copyright: { value: "", isDisplay: false }
  },
  prolindung: {
    isDisplay: true,
    partner: "prolindung",
    company: "KOPERASI KAKITANGAN PETRONAS BERHAD (KOPETRO)",
    email: { value: "infotakaful@kopetro.com.my", isDisplay: true },
    mobile: { value: "+603-2161 1990", isDisplay: true },
    mobile2: { value: "+6012-397 5965", isDisplay: true },
    address: {
      value:
        "B-3-15, Megan Avenue II,<br> No. 12, Jalan Yap Kwan Seng,<br> 50450 Kuala Lumpur",
      isDisplay: true
    },
    copyright: { value: "", isDisplay: false }
  }
};
